import 'jquery';

import '../utils/easypiechart.js';
document.addEventListener('DOMContentLoaded', function (e) {
  jQuery('.chart').easyPieChart({
    size: 112,
    barColor: function (percent) {
      var barColor = '#767676'; // this is default barColor
      if (jQuery(this.el).data('barcolor')) {
        barColor = jQuery(this.el).data('barcolor');
      }
      return barColor;
    },

    scaleLength: 0,
    lineWidth: 8,
    trackColor: '#C4C4C4',
    lineCap: 'circle',
    animate: 2000
  });
  jQuery('.counter_into').each(function () {
    var $this = jQuery(this),
      countTo = $this.attr('data-count');

    jQuery({ countNum: $this.text() }).animate(
      {
        countNum: countTo
      },
      {
        duration: 2000,
        easing: 'swing',
        step: function (row) {
          $this.text(Math.floor(row));
        },
        complete: function () {
          $this.text(this.countNum);
        }
      }
    );
  });

  jQuery('.chart_2').easyPieChart({
    size: 145,
    barColor: function (percent) {
      var barColor = '#767676'; // this is default barColor
      if (jQuery(this.el).data('barcolor')) {
        barColor = jQuery(this.el).data('barcolor');
      }
      return barColor;
    },

    scaleLength: 0,
    lineWidth: 8,
    trackColor: '#C4C4C4',
    lineCap: 'circle',
    animate: 2000
  });
});
